<div #dropdown class="dropdown" [style.width]="width + '%'">
  <div
    class="dropdown-toggle"
    *ngIf="!otherOptionInputShown"
    [class.dropdown-toggle--active]="dropDownOpen"
    [class.disabled]="formControl.disabled"
    (click)="openDropdown($event)"
    (keydown.space)="openDropdown($event)"
    tabindex="0"
  >
    {{ selectedValues || placeholder }}
    <img src="assets/images/red-select.svg" />
  </div>
  <app-error-message
    *ngIf="formControl.errors && !otherOptionInputShown && formControl.touched"
    [validationErrors]="formControl.errors"
  ></app-error-message>
  <div class="dropdown-menu" *ngIf="!otherOptionInputShown" [ngClass]="{ show: dropDownOpen }">
    <div class="dropdown-option" tabindex="0" *ngFor="let option of options; let i = index" (focusout)="i ===  options.length - 1 && openDropdown($event)" (keydown.space)="selectOption($event, option)" (click)="selectOption($event, option)">
      <div class="checkbox"><img *ngIf="isSelected(option.id)" src="assets/images/icons/check-green.svg" /></div>
      {{ option.text }}
    </div>
    <div *ngIf="customOptionEnabled" class="select" (click)="selectOption($event, egyeb)">Kattintson ide egyedi érték megadásához!</div>
  </div>
  <div class="input-cont" *ngIf="otherOptionInputShown">
    <div>
      <app-text-input [helper]="true" placeholder="Egyedi válasz" [required]="true" [formControl]="formControl"></app-text-input>
    </div>
    <img class="check" src="assets/images/icons/check-green.svg" (click)="acceptAndAddValueToTheMasses()" />

    <img src="assets/images/icons/x-green.svg" (click)="nullOutValue()" />
  </div>
</div>
